import axios from 'axios'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { CONSUMERS } from '../../../Utilities/APIs'
// import Logo from '../../Partials/Elements/Logo/Logo'

function VerifyEmail() {

    const {customer} = useSelector(state => state.auth)
    const navigate = useNavigate()
    const {token} = useParams()

    useEffect(() => {
        if (token && token !== 'default') {
            async function verifyCustomer() {
                const verification = await axios.patch(CONSUMERS + 'verify/' + token)
                if (verification.data.isVerified === true) {
                    navigate('/login')
                }
            }
            verifyCustomer()
        }
    }, [token, navigate])

    return (
        <section className="recover_pass two page_padding">
            <div className="container">
                {/* <div className="page_logo">
                    <Logo />
                </div> */}
                <div className="centered_form_wrapper">
                    <div className="form_wrapper">
                        <h3>Verify your email</h3>
                        <div className="input_group">
                            <p className="body_text">
                                A verification mail has been sent to <span style={{color: 'var(--black)'}}>{customer?.email}.</span> Please check your email.
                            </p>
                        </div>
                        <div className="dha_box">
                            <p className="body_text">Didn’t receive a mail?</p>
                            <button type='submit' className='btn_text sign_up'>resend email</button>
                        </div>
                        <div className="dha_box">
                            <p className="body_text">Already verified?</p>
                            <Link to='/login' className='btn_text sign_up'>Login</Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default VerifyEmail